// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ConnectionPollerController from "./connection_poller_controller"
application.register("connection-poller", ConnectionPollerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MessengerAccountNewController from "./messenger_account_new_controller"
application.register("messenger-account-new", MessengerAccountNewController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import UonManagerLinkController from "./uon_manager_link_controller"
application.register("uon-manager-link", UonManagerLinkController)

import UserPasswordController from "./user_password_controller"
application.register("user-password", UserPasswordController)
